import React, { useState } from 'react';
import styled from 'styled-components';

import SubMenu from 'components/SubMenu';
import user from 'assets/windowsIcons/user.png';
import lock from 'assets/windowsIcons/546(32x32).png';
import shut from 'assets/windowsIcons/310(32x32).png';

function FooterMenu({ className, guildName, menuConfig, onClick, onClickPower }) {
  return (
    <div className={className}>
      <header>
        <img className="header__img" src={user} alt="avatar" />
        <span className="header__text">{guildName}</span>
      </header>
      <section className="menu">
        <hr className="orange-hr" />
        <MenuColumn className="menu__left" items={menuConfig.left} onClick={onClick} />
        <MenuColumn className="menu__right" items={menuConfig.right} onClick={onClick} />
      </section>
      <footer>
        <div className="footer__item" onClick={() => onClickPower('logoff')}>
          <img className="footer__item__img" src={lock} alt="" />
          <span>注销</span>
        </div>
        <div className="footer__item" onClick={() => onClickPower('poweroff')}>
          <img className="footer__item__img" src={shut} alt="" />
          <span>关闭计算机</span>
        </div>
      </footer>
    </div>
  );
}

function MenuColumn({ className, items, onClick }) {
  const [hovering, setHovering] = useState(-1);

  return (
    <div className={className}>
      {(items || []).map((item, index) => (
        <MenuItem
          key={`${item.text}-${index}`}
          item={item}
          hover={hovering === index}
          onHover={() => setHovering(index)}
          onClick={onClick}
        />
      ))}
    </div>
  );
}

function MenuItem({ item, hover, onHover, onClick }) {
  const isMenu = item.type === 'menu';

  function handleClick(e) {
    e.stopPropagation();
    if (isMenu) return;
    onClick(item);
  }

  return (
    <div
      className={`menu__item ${hover ? 'active' : ''}`}
      onMouseEnter={onHover}
      onClick={handleClick}
    >
      <img className="menu__item__img" src={item.icon} alt={item.text} />
      <div className="menu__item__texts">
        <div className="menu__item__text">{item.text}</div>
      </div>
      {isMenu && (
        <>
          <div className="menu__arrow" />
          {hover && <SubMenu left="182px" data={item.items} onClick={onClick} />}
        </>
      )}
    </div>
  );
}

export default styled(FooterMenu)`
  font-size: 11px;
  line-height: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #4282d6;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  min-width: 380px;
  header {
    position: relative;
    align-self: flex-start;
    display: flex;
    align-items: center;
    color: #fff;
    height: 54px;
    padding: 6px 5px 5px;
    width: 100%;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    background: linear-gradient(
      to bottom,
      #1868ce 0%,
      #0e60cb 12%,
      #0e60cb 20%,
      #1164cf 32%,
      #1667cf 33%,
      #1b6cd3 47%,
      #1e70d9 54%,
      #2476dc 60%,
      #297ae0 65%,
      #3482e3 77%,
      #3786e5 79%,
      #428ee9 90%,
      #4791eb 100%
    );
    overflow: hidden;
  }
  header:before {
    content: '';
    display: block;
    position: absolute;
    top: 1px;
    left: 0;
    width: 100%;
    height: 3px;
    background: linear-gradient(
      to right,
      transparent 0,
      rgb(255, 255, 255, 0.3) 1%,
      rgb(255, 255, 255, 0.5) 2%,
      rgb(255, 255, 255, 0.5) 95%,
      rgb(255, 255, 255, 0.3) 98%,
      rgb(255, 255, 255, 0.2) 99%,
      transparent 100%
    );
    box-shadow: inset 0 -1px 1px #0e60cb;
  }
  .header__img {
    width: 42px;
    height: 42px;
    margin-right: 5px;
    border-radius: 3px;
    border: 2px solid rgb(222, 222, 222, 0.8);
  }
  .header__text {
    font-size: 14px;
    font-weight: 700;
    text-shadow: 1px 1px rgba(0, 0, 0, 0.7);
  }
  .menu {
    display: flex;
    margin: 0 2px;
    position: relative;
    border-top: 1px solid #385de7;
    box-shadow: 0 1px #385de7;
  }
  .orange-hr {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    display: block;
    height: 2px;
    background: linear-gradient(
      to right,
      rgba(0, 0, 0, 0) 0%,
      #da884a 50%,
      rgba(0, 0, 0, 0) 100%
    );
    border: 0;
  }
  .menu__left {
    background-color: #fff;
    padding: 10px 5px 6px;
    width: 190px;
    display: flex;
    flex-direction: column;
    min-height: 320px;
  }
  .menu__right {
    background-color: #cbe3ff;
    border-left: solid #3a3aff5e 1px;
    padding: 10px 5px 6px;
    width: 190px;
    color: #00136b;
    min-height: 320px;
  }
  .menu__item {
    padding: 1px;
    display: flex;
    align-items: center;
    margin-bottom: 4px;
    min-height: 26px;
    position: relative;
  }
  .menu__item:hover,
  .menu__item.active {
    color: white;
    background-color: #2f71cd;
  }
  .menu__item__texts {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }
  .menu__item__img {
    margin-right: 5px;
    width: 22px;
    height: 22px;
    flex-shrink: 0;
  }
  .menu__item__text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .menu__arrow {
    border: 3.5px solid transparent;
    border-right: 0;
    border-left-color: currentColor;
    position: absolute;
    right: 8px;
  }
  footer {
    display: flex;
    align-self: flex-end;
    align-items: center;
    justify-content: flex-end;
    color: #fff;
    height: 36px;
    width: 100%;
    background: linear-gradient(
      to bottom,
      #4282d6 0%,
      #3b85e0 3%,
      #418ae3 5%,
      #418ae3 17%,
      #3c87e2 21%,
      #3786e4 26%,
      #3482e3 29%,
      #2e7ee1 39%,
      #2374df 49%,
      #2072db 57%,
      #196edb 62%,
      #176bd8 72%,
      #1468d5 75%,
      #1165d2 83%,
      #0f61cb 88%
    );
  }
  .footer__item {
    padding: 3px;
    display: flex;
    margin-right: 10px;
    align-items: center;
    &:hover {
      background-color: rgba(60, 80, 210, 0.5);
    }
    &:hover:active > * {
      transform: translate(1px, 1px);
    }
  }
  .footer__item__img {
    border-radius: 3px;
    margin-right: 2px;
    width: 22px;
    height: 22px;
  }
`;
